import client from '../client';

export type TApiUserArea = {
  id: number;
  name: string;
  value: Array<string>;
  north: string;
  west: string;
  south: string;
  east: string
}

const list = (): Promise<Array<TApiUserArea>> =>
  client.get('/user-area/').then(response => response.data);

export {
  list
};
